import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Linkedin from "../../assets/icons/linkedin.svg";
import Message from "../../assets/icons/message.svg";
import Location from "../../assets/icons/gps.svg";
import "./index.css";
import { useTranslation } from "react-i18next";
import Logo from "../../assets/images/new-logo-icon-white.svg";
import CookieSettingsButton from "../CookieSettingsButton";

const Index = () => {
  const { t } = useTranslation();

  return (
    <footer>
      <Container>
        <div className="footer_wrapper">
          <Row className="m-0">
            <Col lg={4} className="p-0 first_col">
              <div className="first_col_wrapper">
                <h5>
                  <img src={Logo} alt="Logo" style={{ width: "40px" }} />
                </h5>
                <p>{t("slogan_short")}</p>

                <p>{t("slogan_long")}</p>
              </div>
              <ul className="social_link d-sm-flex d-none">
                <li>
                  <a
                    href="https://www.linkedin.com/company/quotabus/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={Linkedin} alt="linkedin" />
                  </a>
                </li>
              </ul>
            </Col>
            <Col lg={7} className="links_wrapper">
              <Row>
                <Col lg={3} xs={6} className="links">
                  <h5>{t("quick_link")}</h5>
                  <ul>
                    <li>
                      <a
                        href="https://app.quotabus.com/VWVOKZL9"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {t("get_quote")}
                      </a>
                    </li>
                    <li>
                      <a href="#how_it_works">{t("how_it_works")}</a>
                    </li>
                    <li>
                      <a href="#faqs">{t("faq")}</a>
                    </li>
                  </ul>
                </Col>
                <Col lg={3} xs={6} className="links">
                  <h5>{t("important_links")}</h5>
                  <ul>
                    <li>
                      <a
                        href="https://partner.quotabus.com/terms-conditions"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {t("terms_of_service")}
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://partner.quotabus.com/privacy-policy"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {t("privacy_policy")}
                      </a>
                    </li>
                    <li>
                      <a href="#contact_us">{t("contact_us")}</a>
                    </li>
                  </ul>
                </Col>
                <Col lg={4} xs={6} className="links contcat_info">
                  <h5>{t("contact_info")}</h5>
                  <ul>
                    <li>
                      <div>
                        <div className="icon_box">
                          <img src={Message} alt="message" />
                        </div>
                        <a
                          href="mailto:info@quotabusnoleggio.com"
                          className="contact_email"
                        >
                          info@quotabusnoleggio.com
                        </a>
                      </div>
                    </li>
                    <li>
                      <div>
                        <span className="icon_box">
                          <img src={Location} alt="location" />
                        </span>
                        <span className="contact_address">
                          Via Valla 5, 27100 PV
                        </span>
                      </div>
                    </li>
                  </ul>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <div className="copyright">
          <p>© 2025 Quotabus srl. All Rights Reserved</p>
          <CookieSettingsButton
            className="cookie_settings_button"
            variant="compact"
          />
        </div>
      </Container>
    </footer>
  );
};

export default Index;
